(function () {
  'use strict';

  var pending = {};
  var sentInMemory = {};
  var storagePrefix = 'starlight_tracking:';

  function sessionKey(eventName, dedupeKey) {
    return storagePrefix + eventName + ':' + String(dedupeKey || window.location.pathname);
  }

  function wasSent(key) {
    if (sentInMemory[key]) return true;
    try {
      return window.sessionStorage.getItem(key) === '1';
    } catch (error) {
      return false;
    }
  }

  function markSent(key) {
    sentInMemory[key] = true;
    try {
      window.sessionStorage.setItem(key, '1');
    } catch (error) {
      // Session storage can be unavailable in privacy-restricted browsers.
    }
  }

  function basePayload() {
    var shopify = window.Shopify || {};
    return {
      page_path: window.location.pathname,
      page_title: document.title,
      market: shopify.country || '',
      language: document.documentElement.lang || ''
    };
  }

  function publish(eventName, eventData, options) {
    options = options || {};
    var key = sessionKey(eventName, options.dedupeKey);
    if (options.dedupe !== false && (wasSent(key) || pending[key])) return;

    pending[key] = true;
    var attempts = 0;

    function dispatch() {
      attempts += 1;
      var shopify = window.Shopify;
      if (!shopify || !shopify.analytics || typeof shopify.analytics.publish !== 'function') {
        if (attempts < 21) {
          window.setTimeout(dispatch, 250);
        } else {
          delete pending[key];
        }
        return;
      }

      var payload = Object.assign(basePayload(), eventData || {});
      var publication;
      try {
        publication = shopify.analytics.publish(eventName, payload);
      } catch (error) {
        delete pending[key];
        return;
      }

      Promise.resolve(publication)
        .then(function (published) {
          delete pending[key];
          if (published !== false) markSent(key);
        })
        .catch(function () {
          delete pending[key];
        });
    }

    dispatch();
  }

  function placementFor(element) {
    if (element.closest('header')) return 'header';
    if (element.closest('footer')) return 'footer';
    return 'content';
  }

  function trackServerConfirmedSuccesses() {
    document.querySelectorAll('[data-starlight-contact-success]').forEach(function (element) {
      var eventName = element.dataset.starlightEvent || 'starlight:contact_form_submitted';
      var formName = element.dataset.starlightForm || 'contact';
      publish(eventName, { form_name: formName }, {
        dedupeKey: window.location.pathname + ':' + formName
      });
    });

    document.querySelectorAll('.newsletter-form__message--success, [data-starlight-newsletter-success]').forEach(function (element, index) {
      var form = element.closest('form');
      var formName = (form && (form.id || form.className)) || 'newsletter';
      publish('starlight:newsletter_signup', { form_name: String(formName) }, {
        dedupeKey: window.location.pathname + ':' + String(formName) + ':' + index
      });
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var placement = placementFor(link);

    if (href.indexOf('tel:') === 0) {
      publish('starlight:phone_clicked', {
        placement: placement,
        destination: href.slice(4).split('?')[0]
      }, { dedupe: false });
    }

    if (href.indexOf('mailto:') === 0) {
      publish('starlight:email_clicked', {
        placement: placement,
        destination: href.slice(7).split('?')[0]
      }, { dedupe: false });

      if (link.matches('[data-pdp3-email-plan]')) {
        publish('starlight:room_plan_requested', {
          placement: placement
        }, { dedupe: false });
      }
    }
  });

  window.StarlightTracking = {
    publish: publish,
    once: function (eventName, eventData, dedupeKey) {
      publish(eventName, eventData, { dedupeKey: dedupeKey });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackServerConfirmedSuccesses);
  } else {
    trackServerConfirmedSuccesses();
  }
})();
